import { ShieldCheck, MessageSquare, Target } from "lucide-react";
import { AUDIENCE } from "../data";

const VALUES = [
  { icon: ShieldCheck, label: "Trabalho cuidado" },
  { icon: MessageSquare, label: "Comunicação clara" },
  { icon: Target, label: "Soluções adequadas a cada necessidade" },
];

export const About = () => (
  <section id="quem-somos" data-testid="about-section" className="section bg-[var(--bg-2)]">
    <div className="wrap grid lg:grid-cols-12 gap-14">
      <div className="lg:col-span-5">
        <span className="eyebrow">Quem somos</span>
        <h2 className="h2 mt-5">Segurança, fiabilidade e bom funcionamento.</h2>
      </div>
      <div className="lg:col-span-7">
        <p className="text-base md:text-lg leading-relaxed text-[var(--text-2)]" data-testid="about-text">
          A SR Soluções Elétrica presta serviços de instalações, reparações e manutenção técnica, com foco na
          segurança, fiabilidade e bom funcionamento de instalações e equipamentos. Trabalhamos para responder
          às necessidades de clientes particulares, empresas e espaços industriais.
        </p>
        <div className="grid sm:grid-cols-2 gap-6 mt-12">
          <div className="panel" data-testid="commitment-card">
            <h3 className="font-display uppercase text-xl font-bold mb-5">O nosso compromisso</h3>
            <ul className="space-y-3">
              {VALUES.map(({ icon: I, label }) => (
                <li key={label} className="flex gap-3 text-[var(--text-2)]"><I size={18} className="text-[var(--blue-2)] shrink-0 mt-0.5" />{label}</li>
              ))}
            </ul>
          </div>
          <div className="panel" data-testid="audience-card">
            <h3 className="font-display uppercase text-xl font-bold mb-5">Para quem trabalhamos</h3>
            <div className="flex flex-wrap gap-2">
              {AUDIENCE.map((a) => (
                <span key={a} className="chip" data-testid={`audience-${a.toLowerCase()}`}>{a}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
